<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <article class="wrapper wrapper-content main-column full-column">
        <section class="animated fadeInRight" v-if="!checkingTerm">
          <!-- profileItem -->
          <div class="ibox">
            <div class="ibox-title">
              <div class="ibox-tools">
                <span class="info-menu">{{$t('profileRegTitleStr')}}</span>
                <span class="info-right">
                </span>
              </div>
            </div>
            <!-- UserElement -->
            <div class="ibox-child">
              <div class="flex-box">
                <span class="info-profimg cursor" v-b-modal.profileModal>
                  <img v-if="editInfo.userIcon" class="img-circle" :src="editInfo.userIcon" alt="">
                  <img v-else class="img-circle" :src="'static/img/noImage.png'" alt="">
                </span>
                <div class="profile-box">
                  <div class="info-profelement ibox-child row">
                    <label class="col-md-4">{{$t('profileUserTitle')}}</label>
                    <div class="col-md-8">
                      <input type="text" class="form-control" v-model="editInfo.userName">
                      <span v-if="!$v.editInfo.userName.nameValidation" class="text-danger font-bold">{{$t('alertRequiredItemStr')}}</span>
                    </div>
                  </div>
                  <div class="info-profelement ibox-child row">
                    <label class="col-md-4">{{$t('departmentStr')}}</label>
                    <div class="col-md-8">
                      <input type="text" class="form-control" v-model="editInfo.dept">
                    </div>
                  </div>
                </div>
                <span class="info-statusimg dropdown" v-if="!willysmEnabled">
                  <profile-drop-down v-on:set-feeling="updateFeeling" :feeling="editInfo.userFeeling"/>
                </span>
              </div>
            </div>
            <!-- /UserElement -->
            <!-- Comment -->
            <div class="ibox-child">
              <div class="row">
                <div class="form-group col-sm-12">
                  <label class="control-label">{{$t('profileBioTitle')}}</label>
                  <textarea class="form-control" :placeholder="$t('settingBioStr')" rows="3" v-model="editInfo.userBio"></textarea>
                </div>
              </div>
            </div>
            <!-- /Comment -->
            <!-- Mail -->
            <div class="ibox-child">
              <div class="row">
                <div id="limited" class="date form-group col-sm-3">
                  <label class="control-label">{{$t('profileMailTitle')}}</label>
                </div>
                <div class="form-group col-sm-9">
                  <div class="input-group">
                    <span class="badge bg-danger">{{$t('notChange')}}</span>
                    <span>{{ editInfo.userEmail }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Mail -->
            <!-- Tell -->
            <div class="ibox-child">
              <div class="row">
                <div id="limited" class="date form-group col-sm-3">
                  <label class="control-label">{{$t('profilePhoneTitle')}}</label>
                </div>
                <div class="form-group col-sm-9">
                  <div class="input-group">
                    <input type="text" class="form-control" v-model="editInfo.userPhone">
                    <span class="text-danger font-bold">{{$t('noHyphenStr')}}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Tell -->
            <!-- Carrer -->
            <div class="ibox-child">
              <div class="row">
                <div class="form-group col-sm-12">
                  <label class="control-label">{{$t('profileSummarayTitle')}}</label>
                  <span class="prof-item">
                    <textarea class="form-control" :placeholder="$t('profileSummarayTitle')" rows="5" v-model="editInfo.careerSummary"></textarea>
                  </span>
                </div>
              </div>
            </div>
            <!-- /Carrer -->
            <div class="ibox-child">
              <div class="row okr-regist-btnset">
                <div class="col-sm-6 col-sm-offset-3 col-xs-12 col-xs-offset-0">
                  <button type="button" class="btn btn-success block m-b" @click="updateProfile">{{$t('saveStr')}}</button>
                </div>
              </div>
            </div>
          </div>
          <!-- /profileItem -->
        </section>
        <b-modal id="profileModal" :title="$t('changePictureStr')" :ok-title="$t('uploadPictureStr')" ref="modal" @hide="handleClickEvent">
          <croppa v-model="myCroppa"
            :width="300"
            :height="300"
            :show-remove-button="true"
            remove-button-color="black"
            :show-loading="true"
            :placeholder="$t('chooseAnImageStr')"
            :placeholder-font-size="16"
            :prevent-white-space="true"
            :accept="'image/*'"
            @file-type-mismatch="onFileTypeMismatch">
          </croppa>
          <!-- <button>アップロード</button> -->
        </b-modal>
      </article>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {storage, i18n, transLanguage, routeRegistPath, willysm} from '@/main.js'
import CommonJs from '@/js/common'
import ProfileDropDown from '@/components/User/ProfileDropDown'
import moment from 'moment'
import { validationMixin } from 'vuelidate'
import WebViewTermsJa from '@/views/_webview/WebViewTermsJA'
import WebViewTermsEn from '@/views/_webview/WebViewTermsEN'
import WebViewTermsZh from '@/views/_webview/WebViewTermsZH'
import WebViewLicenseAgreementJa from '@/views/_webview/WebViewLicenseAgreementJa'
import WebViewLicenseAgreementEn from '@/views/_webview/WebViewLicenseAgreementEn'
import WebViewLicenseAgreementZh from '@/views/_webview/WebViewLicenseAgreementZh'
// import { required } from 'vuelidate/lib/validators'

function byte (str) {
  var length = 0
  for (var i = 0; i < str.length; i++) {
    var c = str.charCodeAt(i)
    if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
      length += 1
    } else {
      length += 2
    }
  }
  return length
}

function nameValidation () {
  if (this.editInfo.userName.trim().length === 0) {
    return false
  } else {
    return true
  }
}

function nameLengthValidation () {
  console.log('editInfob', byte(this.editInfo.userName))
  if (byte(this.editInfo.userName) > 24) {
    return false
  } else {
    return true
  }
}

function deptLengthValidation () {
  console.log('editInfob', byte(this.editInfo.dept))
  if (byte(this.editInfo.dept) > 40) {
    return false
  } else {
    return true
  }
}

function bioLengthValidation () {
  console.log('editInfob', byte(this.editInfo.userBio))
  if (byte(this.editInfo.userBio) > 100) {
    return false
  } else {
    return true
  }
}

function phoneValidation () {
  var validate = true
  var regexp = /^\+?(?:[0-9]?){6,14}[0-9]$/
  if (!this.editInfo.userPhone.match(regexp) && this.editInfo.userPhone) {
    // console.log('電話番号の形式が正しくありません。')
    validate = false
    return false
  }
  if (validate) {
    // console.log('電話番号問題ありません。')
    return true
  }
}

export default {
  name: 'ProfileRegist',
  mixins: [CommonJs],
  mixedins: [validationMixin],
  components: {
    ProfileDropDown,
    WebViewTermsJa,
    WebViewTermsEn,
    WebViewTermsZh,
    WebViewLicenseAgreementJa,
    WebViewLicenseAgreementEn,
    WebViewLicenseAgreementZh
  },
  // store,
  props: {
    readyForState: Boolean
  },
  data: function () {
    return {
      willysmEnabled: willysm.enabled,
      tag: 'progress',
      edit: true,
      agreementModal: false,
      checkingTermFlg: true,
      editInfo: {
        userName: '',
        dept: '',
        userIcon: '',
        userFeeling: 'sunny',
        userBio: '',
        // userEmail: '',
        userEmail: this.currentEmail,
        userPhone: '',
        careerSummary: '',
        language: ''
      },
      uploadImage: '',
      cropImage: '',
      myCroppa: {}
    }
  },
  validations: {
    editInfo: {
      userName: {
        nameValidation,
        nameLengthValidation
        // required
      },
      dept: {
        deptLengthValidation
      },
      userBio: {
        bioLengthValidation
      },
      userPhone: {
        phoneValidation
      }
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'ProfileRegist'
    },
    ...mapGetters([
      'getUserId',
      'getCurrentUser',
      'getCurrentUserInfo'
    ]),
    ...mapGetters('users/', [
      'getUsersByIds'
    ]),
    checkingTerm: {
      get: function () {
        return this.checkingTermFlg
      },
      set: function (v) {
        this.checkingTermFlg = v
      }
    },
    checkForState () {
      console.log('ProfileRegist:checkForState', this.readyForState)
      return this.readyForState
    },
    checkLanguage () {
      return i18n.locale
    },
    checkSetFlag () {
      if (this.getCurrentUser && this.getCurrentUser.showTerms) return true
      else return false
    },
    currentEmail: {
      get: function () {
        if (this.getCurrentUserInfo && this.getCurrentUserInfo.userEmail) return this.getCurrentUserInfo.userEmail
        else return ''
      },
      set: function (value) {
        this.editInfo.userEmail = value
      }
    }
  },
  watch: {
    getCurrentUser: function () {
      // this.currentEmail = this.getCurrentUser
      this.currentEmail = this.getCurrentUser.userEmail
      this.checkingTerm = !!this.getCurrentUser.showTerms
    }
  },
  created: function () {
    console.log('created:waitingForState: ', this.checkForState, this.readyForState)
    console.log('currentUser', this.$firebase.auth().currentUser)
    let cu = this.$firebase.auth().currentUser
    if (cu && cu.displayName) {
      this.checkingTerm = false
    }
    if (cu && cu.email) {
      this.editInfo.email = cu.email
    }
  },
  mounted: function () {
    console.log('mounted:waitingForState: ', this.checkForState, this.readyForState)
    console.log(this.getCurrentUser.showTerms)
    if (this.$route.params && this.$route.params.regist) {
      console.log('this.$route.params::', this.$route.params)
      this.agreementModal = true
    } else if (this.getCurrentUser && this.getCurrentUser.showTerms) {
      console.log('this.getCurrentUser.showTerms::', this.getCurrentUser.showTerms)
      this.agreementModal = true
    } else {
      console.log('you did agree the terms')
      // this.checkingTerm = false
    }
    console.log('browser language', this.checkLanguage)
    if (this.checkLanguage === 'zh_tr') {
      this.editInfo.language = 'zh'
    } else {
      this.editInfo.language = this.checkLanguage
    }
    if (this.getCurrentUserInfo) {
      console.log('log mount')
      if (this.getCurrentUserInfo.userEmail) {
        this.editInfo.userEmail = this.getCurrentUserInfo.userEmail
        this.checkingTerm = false
      }
    } else if (this.$route.params && this.$route.params.userEmail) {
      console.log('log mount', this.$route.params.userEmail)
      this.editInfo.userEmail = this.$route.params.userEmail
    }
  },
  updated: function () {
    console.log('updated:waitingForState: ', this.checkForState, this.readyForState)
    console.log(this.getCurrentUser.showTerms)
    // console.log(this.$route.params)
    if (this.getCurrentUserInfo) {
      console.log('log update')
      this.editInfo.userEmail = this.getCurrentUserInfo.userEmail
    } else if (this.$route.params && this.$route.params.userEmail) {
      console.log('log update', this.$route.params.userEmail)
      this.editInfo.userEmail = this.$route.params.userEmail
    }
  },
  methods: {
    ...mapActions({
      removeTermsFlag: 'removeTermsFlag'
    }),
    ...mapActions('profiles/', {
      // setDefaultUserInfo: 'SET_DEFAULT_USER_INFO',
      setProfile: 'SET_PROFILE',
      setFeeling: 'SET_FEELING',
      removeUser: 'REMOVE_USER'
    }),
    changeLanguage: function (locale) {
      transLanguage(locale)
      try {
        if (window.localStorage) {
          localStorage.setItem('language', locale)
        } else {
          // alert('言語切り替えをするには、ブラウザ設定でLocalStorageを有効にする必要があります')
        }
      } catch (e) {
        // alert('言語切り替えをするには、ブラウザ設定でLocalStorageを有効にする必要があります')
        console.log('storage error::', e)
      }
    },
    updateFeeling: function (value) {
      // コンディションの変更
      if (this.edit) {
        this.editInfo.userFeeling = value
      } else {
        this.setFeeling(value)
      }
    },
    handleClickEvent: function (evt) {
      // console.log(evt)
      if ((evt.trigger === 'backdrop' || evt.trigger === 'cancel' || evt.trigger === 'header-close') && this.myCroppa.imageSet) {
        evt.preventDefault()
        if (confirm(this.$t('confirmDeletePictureStr'))) {
          this.removeCroppa()
        }
      } else if ((evt.trigger === 'backdrop' || evt.trigger === 'cancel' || evt.trigger === 'header-close') && !this.myCroppa.imageSet) {
        this.$refs.modal.hide()
      } else if (evt.trigger === 'ok' && !this.myCroppa.imageSet) {
        evt.preventDefault()
        alert(this.$t('selectPictureStr'))
      } else if (evt.trigger === 'ok' && this.myCroppa.imageSet) {
        this.uploadResizedPhoto()
      }
    },
    removeCroppa: function () {
      this.myCroppa.remove()
      this.$refs.modal.hide()
    },
    // プロフィール画像プロップ処理
    onFileTypeMismatch (file) {
      const $t = this.$t
      this.swal({
        text: $t('orderFileUploadStr'),
        type: 'waning'
      })
      // alert('jpg, gif, png形式でアップして下さい。')
    },
    // onFileSizeExceed (file) {
    //   const $t = this.$t
    //   this.$swal({
    //     text: $t('order2mbFileStr'),
    //     type: 'warning',
    //     animation: false,
    //     customClass: 'animated pulse'
    //   })
    //   // alert('ファイルは2mb以下でアップロードして下さい。')
    // },
    uploadResizedPhoto () {
    //   console.log(this.myCroppa.generateBlob(blob))
      var date = moment()
      let userId = this.getUserId
      var profileImageUrl = (date / 1000) + '.jpg'
      const storageProfilePhotoRef = storage.ref('profilepictures/' + userId)
      const path = profileImageUrl
      const photoImagesRef = storageProfilePhotoRef.child(path)
      console.log('ここ', photoImagesRef)
      // generateBlobで、画像からblobオブジェクトを作成します。
      // blobオブジェクトをそのままputメソッドで、Cloud Storageにアップしています。
      this.myCroppa.generateBlob((blob) => {
        photoImagesRef.put(blob)
          .then((snapshot) => {
            snapshot.ref.getDownloadURL().then((url) => {
              this.editInfo.userIcon = url
            })
          })
          .catch((err) => {
            console.log('upload error:', err)
          })
      })
    },
    updateProfile: function () {
      const $t = this.$t
      // if (
      //   this.$v.editInfo.userName.nameValidation &&
      //   this.$v.editInfo.userName.nameLengthValidation &&
      //   this.$v.editInfo.dept.deptLengthValidation &&
      //   this.$v.editInfo.userBio.bioLengthValidation &&
      //   this.$v.editInfo.userPhone.phoneValidation
      // ) {
      //   this.setProfile(this.editInfo)
      //   this.$router.push({ name: 'OkrList', params: { registed: true } })
      if (!this.$v.editInfo.userName.nameValidation) {
        this.$swal({
          // sweetAlartの処理
          title: $t('popTitleStrType'),
          text: $t('noUserNameStr'),
          showCancelButton: false,
          type: 'warning',
          confirmButtonClass: 'btn btn-success',
          reverseButtons: false,
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        }).then((result) => {
          if (result.value) {
            console.log('true')
          } else {
            console.log('false')
          }
        })
      } else if (!this.$v.editInfo.userName.nameLengthValidation) {
        this.$swal({
          // sweetAlartの処理
          title: $t('popTitleStrType'),
          text: $t('warningUserNameStr'),
          showCancelButton: false,
          type: 'warning',
          confirmButtonClass: 'btn btn-success',
          reverseButtons: false,
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 4000
        }).then((result) => {
          if (result.value) {
            console.log('true')
          } else {
            console.log('false')
          }
        })
      } else if (this.editInfo.dept && !this.$v.editInfo.dept.deptLengthValidation) {
        this.$swal({
          // sweetAlartの処理
          title: $t('popTitleStrType'),
          text: $t('warningdepartmentStr'),
          showCancelButton: false,
          type: 'warning',
          confirmButtonClass: 'btn btn-success',
          reverseButtons: false,
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 4000
        }).then((result) => {
          if (result.value) {
            console.log('true')
          } else {
            console.log('false')
          }
        })
      } else if (this.editInfo.userBio && !this.$v.editInfo.userBio.bioLengthValidation) {
        this.$swal({
          // sweetAlartの処理
          title: $t('popTitleStrType'),
          text: $t('warningCommentStr'),
          showCancelButton: false,
          type: 'warning',
          confirmButtonClass: 'btn btn-success',
          reverseButtons: false,
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 4000
        }).then((result) => {
          if (result.value) {
            console.log('true')
          } else {
            console.log('false')
          }
        })
      } else if (this.editInfo.userPhone && !this.$v.editInfo.userPhone.phoneValidation) {
        this.$swal({
          // sweetAlartの処理
          title: $t('popTitleStrType'),
          text: $t('notTellNumberStr'),
          showCancelButton: false,
          type: 'warning',
          confirmButtonClass: 'btn btn-success',
          reverseButtons: false,
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        }).then((result) => {
          if (result.value) {
            console.log('true')
          } else {
            console.log('false')
          }
        })
      } else {
        console.log('* Profile Regist.')
        if (this.editInfo.userIcon === '') {
          delete this.editInfo.userIcon
        }
        this.setProfile(this.editInfo)
        this.edit = !this.edit
        this.$router.push({ name: routeRegistPath, params: { registed: true } })
      }
    },
    agreeTerms: function () {
      this.agreementModal = false
      this.checkingTerm = false
      console.log(this.checkingTerm, this.checkingTermFlg, this.editInfo.email)
      this.removeTermsFlag()
    },
    rejectTerms: function () {
      console.log('delete targit uid', this.$firebase.auth().currentUser.uid)
      let targerUid = this.$firebase.auth().currentUser.uid
      this.removeUser(targerUid)
      // ここ ユーザーを削除してからサインアウトする
      this.$firebase.auth().currentUser.delete()
        .then(() => {
          console.log('user deleted')
          this.$firebase.auth().signOut()
        })
        .then((user) => {
          console.log('LogOut: ', user)
          this.$router.replace({ name: 'Login' })
        })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
span.text-danger {
  display: inline-block;
  width: 100%;
  margin: 0.5rem 0;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  position: relative;
  margin: auto;
  z-index: 9999;
  width: 60%;
  height: auto;
  padding: 20px 30px;
  background-color: white;
  border-radius: 2px;
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.terms-body{
  width: 100%;
  height: 500px;
  border: solid 5px #c6d4d8;
  border-radius: 5px;
  overflow: auto;
}
.terms-body >>> .app { overflow: visible; }

.agreemnt-btns{
  position:relative;
  text-align: center;
  width: 100%;
  height: auto;
	margin: 0 auto;
  margin-top: 10px
}

.agreemnt-btns button {
  display: inline-block;
}
/* .btn.block {
  width: 10rem;
} */
img.flag {
  width: 2rem;
}
.btn-group {
  display: flex;
  justify-content: space-around;
  display: flex;
  justify-content: space-around;
  margin-top: 3rem;
}
.willysmForm {
  width: 88%;
}
</style>



// WEBPACK FOOTER //
// src/views/user/ProfileRegist.vue